import { ComponentType } from 'react';
import { Provider } from 'react-redux';
import store from '../redux/store';

const withProvider = <T,>(Component: ComponentType<T>) => {
    const WrappedComponent = (props: T) => {
        return (
            <Provider store={store} context={window.DigitalContext}>
                {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
                <Component {...(props as any)} />
            </Provider>
        );
    };

    return WrappedComponent;
};

export default withProvider;
